export default "__VITE_ASSET__CI$C7zWh__"